export default class ServerError {
    constructor(errorCode, detail, status) {
        this.errorCode = errorCode
        this.detail = detail
        this.status = status
    }
}